var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16301",
    "data-name": "Group 16301",
    transform: "translate(-1536 -143.507)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3422",
    "data-name": "Rectangle 3422",
    width: 30,
    height: 30,
    transform: "translate(1536 143.507)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16308",
    "data-name": "Group 16308",
    transform: "translate(1540 114.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16303",
    "data-name": "Group 16303",
    transform: "translate(13.003 44.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16302",
    "data-name": "Group 16302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11441",
    "data-name": "Path 11441",
    d: "M297.053,258.624a4.084,4.084,0,0,0-2.542.877.332.332,0,0,0,.41.523,3.426,3.426,0,0,1,2.132-.736,3.462,3.462,0,1,1-2.931,1.621.332.332,0,1,0-.563-.354,4.125,4.125,0,1,0,3.493-1.932Z",
    transform: "translate(-292.927 -258.624)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16305",
    "data-name": "Group 16305",
    transform: "translate(16.797 45.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16304",
    "data-name": "Group 16304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11442",
    "data-name": "Path 11442",
    d: "M381.321,299.127h-2.275v-2.275a.332.332,0,0,0-.665,0v2.607a.332.332,0,0,0,.332.332h2.607a.332.332,0,1,0,0-.665Z",
    transform: "translate(-378.382 -296.52)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16307",
    "data-name": "Group 16307",
    transform: "translate(0 34.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16306",
    "data-name": "Group 16306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11443",
    "data-name": "Path 11443",
    d: "M20.31,43.782V38.016a1.573,1.573,0,0,0-1.571-1.571h-.713v-.818a1.324,1.324,0,1,0-2.647,0v.818H13.661v-.818a1.324,1.324,0,1,0-2.647,0v.818H9.3v-.818a1.324,1.324,0,1,0-2.647,0v.818H4.932v-.818a1.324,1.324,0,0,0-2.647,0v.818H1.571A1.573,1.573,0,0,0,0,38.016v.164a.332.332,0,1,0,.665,0v-.164a.908.908,0,0,1,.907-.907h.713v.818a1.324,1.324,0,1,0,2.647,0v-.818H6.649v.818a1.324,1.324,0,1,0,2.647,0v-.818h1.717v.818a1.324,1.324,0,1,0,2.647,0v-.818h1.717v.818a1.324,1.324,0,1,0,2.647,0v-.818h.713a.908.908,0,0,1,.907.907v2.346H.665V39.51a.332.332,0,1,0-.665,0V50.981a1.573,1.573,0,0,0,1.571,1.571H13.392a5.593,5.593,0,0,0,7.042.354.332.332,0,1,0-.393-.536,4.934,4.934,0,1,1-1.459-8.7l.028.009a4.934,4.934,0,0,1,2.337,7.833.332.332,0,0,0,.514.422,5.6,5.6,0,0,0-1.15-8.152ZM4.267,37.927a.659.659,0,0,1-1.318,0v-2.3a.659.659,0,1,1,1.318,0Zm4.365,0a.659.659,0,0,1-1.318,0v-2.3a.659.659,0,1,1,1.318,0Zm4.365,0a.659.659,0,0,1-1.318,0v-2.3a.659.659,0,1,1,1.318,0Zm4.365,0a.659.659,0,0,1-1.318,0v-2.3a.659.659,0,1,1,1.318,0Zm-8.838,3.1h3.264V44.2H8.523ZM3.929,51.888H1.571a.908.908,0,0,1-.907-.907v-2.27H3.929v3.177Zm0-3.842H.665V44.869H3.929v3.177Zm0-3.842H.665V41.027H3.929V44.2Zm.665.665H7.858v3.177H4.594Zm3.264,7.019H4.594V48.711H7.858Zm0-7.684H4.594V41.027H7.858Zm.665.665h3.264v1.839a5.568,5.568,0,0,0-.247,1.338H8.523Zm4.235,7.019H8.523V48.711h3.016A5.525,5.525,0,0,0,12.758,51.888Zm-.306-6.576v-.443h.324Q12.6,45.082,12.452,45.312Zm3.264-2.344A5.592,5.592,0,0,0,13.411,44.2h-.959V41.027h3.264Zm3.929.416A5.567,5.567,0,0,0,18.67,43L18.649,43a5.61,5.61,0,0,0-2.268-.16V41.027h3.264Z",
    transform: "translate(0 -34.303)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.fec202f5b7ac8c4a7475c463131190d1.svg";
export { ForwardRef as ReactComponent };